import React, { ComponentType, FC } from "react";
import { useParams } from "react-router-dom";
import { FeaturesProvider } from "lib/containers";

function withFeatures<Props>(Component: ComponentType<Props>): FC<Props> {
  const Consumer: React.FC<Props> = (props) => {
    return <Component {...{ ...props }} />;
  };

  return (props) => {
    const {
      buildingID,
      strategyID,
      floorID,
      id: projectID,
    } = useParams<{ [key: string]: string }>();
    return (
      <FeaturesProvider
        initialState={{ floorID, strategyID, buildingID, projectID }}
      >
        <Consumer {...{ ...props }} />
      </FeaturesProvider>
    );
  };
}

export default withFeatures;
